import { Component, OnInit, Input } from '@angular/core';
import { TableRadioButtonLabelValue } from 'src/app/utils/interfaces/old/table-radio-button-interface';

@Component({
  selector: 'frg-table-radio-button',
  templateUrl: './table-radio-button.fragment.html',
  styleUrls: ['./table-radio-button.fragment.scss']
})

export class TableRadioButtonFragment implements OnInit {

  @Input() public headerLabel: string;
  @Input() public headerValues: Array<TableRadioButtonLabelValue> = [];
  @Input() public bodyValues: Array<TableRadioButtonLabelValue> = [];

  /**
   * Pour utiliser ce fragment, il faut que les 'value' de l'object 'headerValues'
   * correspondent aux 'value' de 'bodyValues'.
   * C'est cette correspondance qui permet un fonctionnement cohérent du fragment.
   *
   * Exemple :
   *
   * headerValues = [
   *  { label: 'Contrôle total', value: '0' },
   *  { label: 'Ecriture', value: '1' },
   *  { label: 'Lecture', value: '2' },
   *  { label: 'Aucun', value: '3' },
   * ];
   *
   * bodyValues = [
   *  { label: 'Administration', value: '0' },
   *  { label: 'Compta', value: '1' },
   *  { label: 'Patient', value: '1' },
   *  { label: 'Agenda', value: '3' },
   * ];
   *
   * Ce qui nous permettra d'avoir un affichage indiquant :
   *
   * Administration =>  Contrôle total
   * Compta         =>  Ecriture
   * Patient        =>  Ecriture
   * Agenda         =>  Aucun
   */

  constructor() { }

  ngOnInit(): void {
  }

  isDisabled(actualValue: TableRadioButtonLabelValue, shownValue: string) {
    if (!actualValue.disabledValues || actualValue.disabledValues.length == 0) {
      return null;
    } else {
      if (actualValue.disabledValues.some((disableValue) => disableValue == shownValue)) {
        return "disabled";
      }
    }
    return null;
  }

}
